import { render, staticRenderFns } from "./envPage.vue?vue&type=template&id=bc0140de&scoped=true&"
import script from "./envPage.vue?vue&type=script&lang=js&"
export * from "./envPage.vue?vue&type=script&lang=js&"
import style0 from "./envPage.vue?vue&type=style&index=0&id=bc0140de&scoped=true&lang=css&"
import style1 from "./envPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0140de",
  null
  
)

export default component.exports